const sheet_url = 'https://sheets.googleapis.com/v4/spreadsheets/';
const spreadsheet_id = '1vQOzRCG7PNMacMqTGIE7WdGEuW-ytZz_08t9Gh0o4p8';
const tab_name = 'TW';
const api_key = 'AIzaSyBDT9cHgrg-aV-6oZmvTL3kkVIbKi4HMGQ';

function createDynamicKeyObject(obj, keys, value) {
  let key = keys.shift();

  if (keys.length === 0) {
    obj[key] = value;
  } else {
    if (!obj[key]) {
      obj[key] = {};
    }

    createDynamicKeyObject(obj[key], keys, value);
  }

  return obj;
}
export async function getTranslationSheet(lang) {
  const baseURL = sheet_url + spreadsheet_id + "/values/" + lang + "?key=" + api_key;
  const sheetRes = await fetch(`${baseURL}`, {
    method: 'get',
  });
  const rowData = await sheetRes.json();
  let mapData = {};
  rowData.values.forEach((row, idx) => {
    const group = row[0].split('_');
    group.push(row[1]);
    createDynamicKeyObject(mapData, group, row[2]);
  });
  
  return Promise.resolve(mapData)
}
